





































import {Vue, Component} from 'vue-property-decorator';

@Component({
  name: 'List2x2',
  props: {
    titleTag: {
      type: String,
      default: 'h3',
    },
    blocks: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: Object,
      default: () => {},
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeEl: [],
    };
  },
  methods: {
    activate(el) {
      const elementNumber = this.activeEl.indexOf(el);
      elementNumber === -1 ? this.activeEl.push(el) : this.activeEl.splice(elementNumber, 1);
    },
  },
})
export default class List2x2 extends Vue {
}
